import { getBooleanFeatureFlag } from '@atlassian/jira-portfolio-3-common/src/feature-flags';

/**
 * this is a permanent feature flag and its feature only enabled for our internal hello customers
 * https://hello.atlassian.net/wiki/spaces/~388547371/pages/2866539946/ARJ+-+Asset+Field+-+Software+Requirement+Spec
 */
const isAssetCustomFieldForInternalEnabled = () =>
	getBooleanFeatureFlag('asset-custom-field-internal-support_an36a');

export default isAssetCustomFieldForInternalEnabled;
